import React, { useEffect, useMemo, useState } from 'react';
import { url } from '../../../utils/variables';
import { uploadImages } from '../../../utils/functions';
import ImagePickerModal from '../../master/ImagePickerModal';
import addImage from '../../../assets/images/add_image.png';
import { useTranslation } from 'react-i18next';
import ImageZoom from '../../master/ImageZoom';
import Modal from '../../master/Modal';

export default function ExpertDocs({ data }) {

    const [attachments, setAttachments] = useState([]);
    const { t } = useTranslation();
    const [showImage , setShowImage] = useState(null);

    const docsCount = useMemo(() => (
        attachments.filter(itm => itm.filename.includes('expert_docs')).length + 1
    ), [attachments]);

    useEffect(() => {
        if (!data.attachments) return;
        setAttachments(data.attachments);
    }, [data.attachments]);

    function finishUpload(image, name, done) {
        uploadImages({
            id: data.id,
            type: 'user',
            name,
            image,
            done,
            callback: (img) => {
                setAttachments(prevState => ([
                    ...prevState,
                    img,
                ]));
            },
        });
    }

    return (
        <>
        <div className='image-box mt20'>
            <p>{t('Needed images')}:</p>
            <p>1-{t('All pages of ID card')}</p>
            <p>2-{t('Front and back of ID card')}</p>
            <p>3-{t('Front and back of car license')}</p>
            <p>4-{t('Duty end card')}</p>
            <p>5-{t('The last degree')}</p>
            <p>6-{t('Sign image')}</p>
            <div className='image-parent mt10'>
                {
                    attachments.map(img => (
                        <div className='img' key={img.id}>
                            <img src={`${url}/files?uid=${img.uid}&width=50&height=50`} alt='img' onClick={() =>setShowImage(img.uid)}/>
                        </div>
                    ))
                }
                <div className='img'>
                    <ImagePickerModal
                        renderBtn={
                            <img className='mt5 defaultImage' data-content={t('Add')} src={addImage}
                                 alt='img'/>
                        }
                        upload={(image, done) => finishUpload(image, `expert_docs${docsCount}`, done)}
                    />
                </div>
            </div>
        </div>
        <Modal visible={showImage}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setShowImage(null)}
                />
                <ImageZoom imgUid={showImage}/>
            </div>
        </Modal>
        </>
    );
}
